"use strict";
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import extend from "lodash/extend";
import includes from "lodash/includes";
import isString from "lodash/isString";
import Promise from "bluebird";
import * as $ from "jquery";
import Log from "./Log";
import easyXDM from "easyxdm";
import { updateConnection, uploadActivityFileSuccess } from "../actions";
import store from "../store";
Promise.config({
    warnings: false
});
var SANE_RESOLVE_CODES = {
    POST: [
        200,
        201,
        204,
        207
    ],
    PUT: [
        200,
        201,
        204,
        207
    ],
    GET: [
        200,
        201,
        204,
        207
    ],
    DELETE: [
        200,
        201,
        204,
        207
    ]
};
/**
 * This will parse a url in it's different parts
 * Thanks to http://stackoverflow.com/a/21553982/1249951
 * @param href
 * @returns {*|{protocol: *, host: *, hostname: *, port: *, pathname: *, search: *, hash: *}}
 */ var parseURL = function parseURL(href) {
    var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };
};
var _endPoints = {}; // easyXDM instances for different endpoints
var tm;
var trackTimeoout = function() {
    tm = setTimeout(function() {
        console.error("Engagement Server does not respond or can`t be reached.");
        var endpoints = Object.keys(_endPoints);
        if (endpoints.length) {
            var ep = endpoints[0].match(/(http[s]?|ftp)?:?\/?\/?(.+)/)[2];
            store.dispatch(updateConnection({
                endpoint: ep,
                status: 408,
                reason: "Engagement Server does not respond or can`t be reached."
            }));
        } else {
            console.error("No Enpoints specified");
        }
    }, 10000);
};
/**
 * This function creates a custom easyXDM Object for a given endpoint
 * @param endPoint {String} a host + protocol
 * @returns {{ajax: Function}}
 */ var createXDMEndpoint = function createXDMEndpoint(endPoint) {
    trackTimeoout();
    Log.log("creating an XDM for " + endPoint);
    var rpc = new easyXDM.Rpc({
        // local: "../name.html",
        // swf: _endPoint + "/xdm/cors/../easyxdm.swf",
        remote: endPoint + "/xdm/cors/index.html",
        // remoteHelper: endPoint + "/xdm/name.html"
        onReady: function onReady() {
            Log.log("xdm is rdy");
            clearTimeout(tm);
        }
    }, {
        remote: {
            request: {}
        },
        local: {
            /**
         * This function will be invoked automatically (by xdm), when an upload completed.
         *
         * Response is object, which contains a target (the object, to which a file is attached),
         *  and a file object, which represents the uploaded file statistic. type is a string
         *  that will represent the name of the context => e.g. "activity"
         * @param {target:*, type:*, file:*}
         */ returnUploadResponse: function returnUploadResponse(response) {
                store.dispatch(uploadActivityFileSuccess({
                    result: {
                        file: response.file,
                        target: response.target,
                        type: response.type
                    }
                }));
            }
        }
    });
    // This function mimics a .ajax call to jQuery, but uses the XDM RPC
    return {
        ajax: function ajax(opts) {
            rpc.request({
                method: opts.type,
                url: opts.url,
                data: opts.data,
                headers: easyXDM.apply(opts.headers, {
                    "Content-Type": opts.contentType
                }),
                dataType: opts.dataType
            }, function(result) {
                var data = result.data;
                var status = result.status;
                var xhr = result.xhr;
                try {
                    data = JSON.parse(data);
                } catch (e) {
                // leave it as it is
                }
                opts.success(data, status, xhr);
            }, function(err) {
                var result, data, status, xhr;
                result = err.data;
                status = result ? result.status : "";
                xhr = result ? result.xhr : null;
                if (result) {
                    try {
                        data = JSON.parse(result.data);
                    } catch (e) {
                        data = result.data;
                    }
                } else {
                    data = {};
                }
                opts.error(xhr, status, data);
            });
        }
    };
};
var safelyCreateXDMEndpoint = function safelyCreateXDMEndpoint(endPoint) {
    // TODO: this does not implement CORS, thus it is not working!!!!!!
    // TODO: Needs a new solution!!!
    return {
        ajax: function ajax(opts) {
            $.get(endPoint + "/xdm/cors/index.html", function() {
                createXDMEndpoint(endPoint).ajax(opts);
            }).catch(function(err) {
                opts.error(err, err.status, err.responseText);
            });
        }
    };
};
/**
 * Return a object that works like jQuery.ajax
 *  but takes in consideration if it needs to handle cross domain calls
 * @param url
 * @returns {{ajax: Function}}
 */ var createOrFindAJAX = function createOrFindAJAX(url) {
    var parsedURL = parseURL(url);
    var endPoint;
    var retval = {};
    if (parsedURL === null) {
        // Local Request
        retval.ajax = function(opts) {
            $.ajax(opts);
        };
    } else {
        endPoint = parsedURL.protocol + "//" + parsedURL.host;
        if (!_endPoints[endPoint]) {
            _endPoints[endPoint] = createXDMEndpoint(endPoint);
        }
        retval.ajax = _endPoints[endPoint].ajax;
    }
    return retval;
};
/**
 * Generic Function for a jsonRequest
 * @param method
 * @param url
 * @param data
 * @param headerData
 * @param success
 * @returns {*}
 */ var jsonRequest = function jsonRequest(method, url, data, headerData, success) {
    var requestor = createOrFindAJAX(url);
    var purl = parseURL(url);
    if (typeof success === "function") {
        Log.warn("AjaxUtils> passing a success handler in func-call is deprecated. Use the promise instead!!");
    }
    headerData = !headerData ? {} : headerData;
    return new Promise(function(resolve, reject) {
        extend(headerData, {
            "Chache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: -1
        });
        requestor.ajax({
            type: method,
            url: url,
            data: data,
            headers: headerData,
            success: function success1(_data, status, xhr) {
                // Check if we receive JSON or Plain Text and parse it if necessary
                if (isString(_data)) {
                    console.log("received data", _data);
                    Log.warn("Data received as Plain Text, should be of Type JSON. Trying to interpreting it anyway.");
                // TODO: throw an exception to airbrake?
                }
                if (includes(SANE_RESOLVE_CODES[method], xhr.status || status)) {
                    resolve(_data);
                } else {
                    reject({
                        status: xhr.status || status,
                        textStatus: status,
                        errorThrown: _data
                    });
                }
                if (typeof success === "function") {
                    success(_data, status, xhr);
                }
                store.dispatch(updateConnection({
                    endpoint: purl ? purl.host : "localhost",
                    status: xhr.status,
                    reason: includes(SANE_RESOLVE_CODES[method], xhr.status) ? status : _data
                }));
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                store.dispatch(updateConnection({
                    endpoint: purl ? purl.host : "localhost",
                    status: jqXHR.status,
                    reason: errorThrown
                }));
                reject({
                    status: jqXHR.status,
                    textStatus: textStatus,
                    errorThrown: errorThrown
                });
            },
            dataType: "json",
            contentType: "application/json"
        });
    });
};
var AjaxUtils = {
    /**
   * @param url {string}
   * @param data {object}
   * @param header {object}
   * @param success {function}
   * @return {Promise} to resove the ajaxy request
   */ postJSON: function postJSON(url, data, header, success) {
        return jsonRequest("POST", url, data, header, success);
    },
    deleteJSON: function deleteJSON(url, data, header, success) {
        return jsonRequest("DELETE", url, data, header, success);
    },
    putJSON: function putJSON(url, data, header, success) {
        return jsonRequest("PUT", url, data, header, success);
    },
    getJSON: function getJSON(url, data, header, success) {
        return jsonRequest("GET", url, data, header, success);
    },
    upload: function upload(url, attrs, headerData) {
        var onProgress = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function(progress) {};
        var purl = parseURL(url);
        return new Promise(function(resolve, reject) {
            if (!window.FormData) {
                reject({
                    status: 600,
                    textStatus: "Form Data is not supported",
                    errorThrown: "Form Data is not supported"
                });
            } else {
                var requestor = createOrFindAJAX(url);
                var data = new FormData();
                data.append("token", headerData.Authorization);
                attrs.forEach(function(obj, i) {
                    Object.keys(obj).forEach(function(key) {
                        if (obj[key]) {
                            if (_instanceof(obj[key], File)) {
                                data.append(key, obj[key], obj[key].name);
                            } else {
                                data.append(key, obj[key]);
                            }
                        }
                    });
                });
                $.ajax({
                    url: url,
                    data: data,
                    cache: false,
                    headers: headerData,
                    contentType: false,
                    processData: false,
                    type: "POST",
                    xhr: function() {
                        var xhr = $.ajaxSettings.xhr();
                        if (xhr.upload) {
                            xhr.upload.addEventListener("progress", onProgress, false);
                        }
                        return xhr;
                    },
                    success: function(_d) {
                        resolve(_d);
                    },
                    error: function(jqXHR, textStatus, errorThrown) {
                        store.dispatch(updateConnection({
                            endpoint: purl ? purl.host : "localhost",
                            status: jqXHR.status,
                            reason: errorThrown
                        }));
                        reject({
                            status: jqXHR.status,
                            textStatus: textStatus,
                            errorThrown: errorThrown
                        });
                    }
                });
            }
        });
    }
};
export default AjaxUtils;
